export default __webpack_public_path__ + "static/media/running.7b4be6f6.png";